export default { Loading: 'Încărcare' };
